import MicroContentModel from "../models/MicroContentModel";

const state = () => ({
  microContent: {}
});

const getters = {
  //getMicroContent: state => state.microContent
  getMicroContent: function(state) {
    return state.microContent;
  }
};

const mutations = {
  AddMicroContent(state, microContent) {
    state.microContent = microContent;
  }
};

const actions = {
  async FetchMicroContent({ commit }) {
    const microContent = await MicroContentModel();
    commit("AddMicroContent", microContent);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
